import { store } from '@utils/configStore'
import administratorReducer from './slices'

export const injectAdministratorManagement = () => store.injectReducer('administrator', administratorReducer)
